import { CdkVirtualScrollViewport } from "@angular/cdk/scrolling";
import { Component, Input, ViewChild } from "@angular/core";
import { NzSafeAny } from "ng-zorro-antd/core/types";
import { NzOptionContainerComponent } from "ng-zorro-antd/select";
import { UiSelectItemInterface, UiSelectModeType } from "@webapp/ui/select/select.models";

@Component({
  selector: "ui-option-container",
  exportAs: "uiOptionContainer",
  templateUrl: "option-container.component.html",
  styles: [".scrollbar-space-reserved { scrollbar-gutter: stable }"],
})
export class UiOptionContainerComponent extends NzOptionContainerComponent {
  @Input() public mode: UiSelectModeType = "default";
  @Input() public listOfContainerItem: UiSelectItemInterface[] = [];
  @Input() public keyboardActivatedValue: NzSafeAny;
  // Equals to default value of UiSelectComponent property uiOptionOverflowSize
  @Input() public reserveScrollbarSpace = this.maxItemLength >= 8;
  @ViewChild(CdkVirtualScrollViewport, { static: true }) public cdkVirtualScrollViewport!: CdkVirtualScrollViewport;

  private scrolledIdx = 0;

  public onScrolledIndexChange(index: number): void {
    this.scrolledIdx = index;
    super.onScrolledIndexChange(index);
  }

  public scrollToActivatedValue(): void {
    const keyboardActivatedValueIndex = this.listOfContainerItem.findIndex((i) => this.compareWith(i.key, this.keyboardActivatedValue));
    const activatedValueIndex = this.listOfContainerItem.findIndex((i) => this.compareWith(i.key, this.activatedValue));
    const index = keyboardActivatedValueIndex > activatedValueIndex ? keyboardActivatedValueIndex : activatedValueIndex;

    if (index < this.scrolledIdx || index >= this.scrolledIdx + this.maxItemLength) {
      this.cdkVirtualScrollViewport.scrollToIndex(index || 0);
    }
  }

  get maxBufferPx(): number {
    return Math.max(this.itemSize * this.maxItemLength, this.itemSize * this.listOfContainerItem.length);
  }
}
